import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  ViewChild,
  TemplateRef,
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { IUser } from 'src/app/core/models/user.model';
import { AuthService } from 'src/app/core/services/auth.service';
import { Role } from 'src/app/core/models/role';
import {
  NgbCalendar,
  NgbDateParserFormatter,
  NgbModal,
  NgbModalOptions,
} from '@ng-bootstrap/ng-bootstrap';
import { Form, NgForm } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { CustomerService } from 'src/app/core/services/customer.service';
import { TranslateService } from '@ngx-translate/core';
import { sharedDataService } from 'src/app/core/services/sharedData.service';
import { HttpClient } from '@angular/common/http';
import { ClientsInvoicesComponent } from '../modals/clients-invoices/clients-invoices.component';

@Component({
  selector: 'app-customer-card',
  templateUrl: './customer-card.component.html',
  styleUrls: ['./customer-card.component.css'],
})
export class CustomerCardComponent implements OnInit {
  currentUser: IUser;

  @Input() customer;
  @Input() customerId;
  @Input() showChangePassword: boolean;

  @Output() editCustomerOut = new EventEmitter<Form>();
  @Output() addCustomerCredit = new EventEmitter<string>();
  @Output() changePassword = new EventEmitter<string>();
  @Output() deleteCustomerOut = new EventEmitter<string>();
  @Output() reloadEditCustomerOut = new EventEmitter<Object>();
  @Output() reloadDeleteCustomerOut = new EventEmitter<string>();
  @Output() reloadCustomers = new EventEmitter<string>();

  private dialogOptions: NgbModalOptions = {
    backdropClass: 'dark-backdrop',
    centered: true,
    windowClass: 'window-modal',
  };
  modalEditCustomer;
  editCustomer;
  modalDeleteCustomer;
  modalAddCustomerCredit;
  customerToAddCredit;
  @ViewChild('dialogEditCustomer') public dialogEditCustomer: TemplateRef<any>;
  @ViewChild('dialogAddCustomerCredit')
  public dialogAddCustomerCredit: TemplateRef<any>;
  toggleCustomerSettings = false;
  customerSettings = null;
  toggleChangeCustomer = false;
  customersData = null;
  selectedCustomer = null;
  showCustomers = false;
  searchCustomersParam = '';
  customersSearch = [];
  transferToParent = false;

  @ViewChild('dialogClientsInvoices') private dialogClientsInvoices: ClientsInvoicesComponent;

  constructor(
    public router: Router,
    private route: ActivatedRoute,
    private authService: AuthService,
    private modalService: NgbModal,
    private customerService: CustomerService,
    private sharedData: sharedDataService,
    private toastr: ToastrService,
    private translate: TranslateService,
    private calendar: NgbCalendar,
    public formatter: NgbDateParserFormatter,
    private http: HttpClient
  ) {}

  ngOnInit(): void {
    this.authService.LoggedinUser.subscribe((user) => {
      this.currentUser = user;
    });
  }

  /**
   * Shows modal for edit customer
   * @param customer
   */
  showDialogEditCustomer(customer) {
    this.editCustomer = customer;
    this.modalEditCustomer = this.modalService.open(
      this.dialogEditCustomer,
      this.dialogOptions
    );
    this.modalEditCustomer.result.then(
      (result) => {},
      (reason) => {
        this.editCustomer = null;
        this.logoFile = null;
        this.previewLogo = null;
      }
    );
  }

  /**
   * edit customer
   * @param form - is ngForm with field to edit customer
   * @returns
   */
  sendEditCustomer(form: NgForm) {
    console.log(form.form.value);
    if (!form.form.valid) {
      return this.translate.get('errors.fillAllFields').subscribe((text: string) => {
            this.toastr.error(text);
          });
    }

    const editData = form.form.value;

    let body = {};

    Object.keys(this.editCustomer).forEach((key) => {
      if (key in editData) {
        if (this.editCustomer[key] !== editData[key]) {
          body[key] =
            editData[key] === '' || editData[key] === null
              ? null
              : editData[key];
        }
      }
    });

    if (Object.keys(body).length === 0 && body.constructor === Object) {
      console.info('No changes.');
      return;
    }

    console.log(body);

    this.customerService.patch(body, this.editCustomer.id).subscribe(
      (customer) => {
        this.translate
          .get('settings.userUpdatedInfo')
          .subscribe((text: string) => {
            this.toastr.success(text);
          });

        this.reloadEditCustomerOut.emit({ customer });
        this.modalEditCustomer.close();
      },
      (error) => {
        this.toastr.error(error.message);
      }
    );
  }

  logoFile = null;
  previewLogo = null;
  chooseLogo() {
    const element: HTMLElement = document.getElementById(`logo`) as HTMLElement;
    element.click();
  }

  getFile(event) {
    this.logoFile = event.target.files[0];
    if (!this.logoFile.type.match('image.*')) {
      return this.translate.get('errors.pleaseUploadImage').subscribe((text: string) => {
        this.toastr.error(text);
      });
    }

    this.editCustomer ? this.uploadLogo() : this.readURL(this.logoFile);
  }

  readURL(image) {
    const reader = new FileReader();
    reader.addEventListener(
      'load',
      () => {
        this.previewLogo = reader.result;
      },
      false
    );
    if (image) {
      reader.readAsDataURL(image);
    }
  }

  /**
   * Uploads logo
   */
  uploadLogo() {
    const formdata = new FormData();
    formdata.append('logo', this.logoFile);

    this.customerService.patch(formdata, this.editCustomer.id).subscribe(
      (customer) => {
        this.toastr.success('Logo updated.');
        this.reloadEditCustomerOut.emit({ customer });
        this.editCustomer = null;
        this.logoFile = null;
        this.previewLogo = null;
        this.modalEditCustomer.close();
      },
      (error) => {
        this.toastr.error(error.message);
      }
    );
  }

  /**
   * Open confirm modal to delete customer
   * @param content
   */
  customerToDelete(content) {
    this.modalDeleteCustomer = this.modalService.open(
      content,
      this.dialogOptions
    );
    this.modalEditCustomer.close();
  }

  deleteCustomer() {
    this.customerService.deleteCustomer(this.editCustomer.id).subscribe(
      (response) => {
        this.reloadDeleteCustomerOut.emit(this.editCustomer.id);
        this.editCustomer = null;
        this.toastr.success('Customer deleted.');
        this.modalEditCustomer.close();
        this.modalDeleteCustomer.close();
      },
      (error) => {
        this.toastr.error(error.message);
      }
    );
  }

  showDialogAddCustomerCredit(customer) {
    this.customerToAddCredit = customer;
    this.modalAddCustomerCredit = this.modalService.open(
      this.dialogAddCustomerCredit,
      this.dialogOptions
    );
    this.modalAddCustomerCredit.result.then(
      (result) => {},
      (reason) => {}
    );
  }

  sendCustomerCredit(form: NgForm) {
    const transferCredit = form.form.value.credit;
    const creditType = form.form.value.creditType || 'credits';
    if (!transferCredit) {
      this.translate.get('customer.creditError').subscribe((text: string) => {
        this.toastr.error(text);
      });
      return;
    }

    if (transferCredit < 1) {
      const credit = -transferCredit;
      if (credit > +this.customerToAddCredit.credits) {
        this.toastr.error(
          `You can enter credit up to ${this.customerToAddCredit.credits}`
        );
        return;
      }
    }

    const fromCustomer = this.customerId;

    if (fromCustomer) {
      this.customerService
        .transferCredits(
          this.customerToAddCredit.id,
          transferCredit,
          fromCustomer,
          creditType
        )
        .subscribe(
          (customer) => {
            this.toastr.success('Successfully add credit');
            this.reloadEditCustomerOut.emit({ customer, transferCredit });
            this.modalAddCustomerCredit.close();
          },
          (error) => {
            this.toastr.error(error.message);
            this.modalAddCustomerCredit.close();
          }
        );
    } else {
      this.customerService
        .addCredit(this.customerToAddCredit.id, transferCredit, creditType)
        .subscribe(
          (customer) => {
            this.toastr.success('Successfully add credit');
            this.reloadEditCustomerOut.emit({ customer, transferCredit });
            this.modalAddCustomerCredit.close();
          },
          (error) => {
            this.toastr.error(error.message);
            this.modalAddCustomerCredit.close();
          }
        );
    }
  }

  showDialogChangePassword(customer) {
    this.changePassword.emit(customer);
  }

  navigateToCustomer(customer) {
    this.sharedData.appId = null;
    this.currentUser.role.name === Role.ROOT
      ? this.router.navigate(['root/customers/', customer.id])
      : this.currentUser.customerId === customer.parentId
      ? this.router.navigate([customer.id], { relativeTo: this.route })
      : this.router.navigate(['..', customer.id], { relativeTo: this.route });
  }

  navigateToCustomerInvoices(customer) {
    this.currentUser.role.name === Role.ROOT
      ? this.router.navigate(['root/customers/', customer.id, 'invoices'])
      : this.currentUser.customerId === customer.parentId
      ? this.router.navigate([customer.id, 'invoices'], {
          relativeTo: this.route,
        })
      : this.router.navigate(['..', customer.id, 'invoices'], {
          relativeTo: this.route,
        });
  }


  async openDialogClientsInvoices(customer) {
    this.editCustomer = customer;
    return await this.dialogClientsInvoices.open();
  }

  infoEmail = null;
  showCustomerSettings(customer) {
    this.editCustomer = customer;
    this.infoEmail = customer.infoEmail;
    this.customerService
      .getCustomerSettings(customer.id)
      .subscribe(
        (res) => {
          this.customerSettings = res;
          this.toggleCustomerSettings = true;
        },
        (err) => {}
      );
  }

  handleCloseSettings() {
    this.toggleCustomerSettings = false;
    this.customerSettings = null;
    this.editCustomer = null;
  }

  patchCreditsNotification(event) {
    const notify = event.target.checked;

    const body = {
      creditsNotificationEnabled: notify,
    };

    this.updateCustomerSettings(body);
  }

  updateTreshold() {
    const body = {
      creditsNotificationThreshold:
        this.customerSettings.creditsNotificationThreshold,
    };

    this.updateCustomerSettings(body);
  }

  updateInfoEmail() {
    const body = {
      infoEmail: this.infoEmail || null,
    };
    console.log(body);
    this.customerService.patch(body, this.editCustomer.id).subscribe(
      (customer) => {
        this.translate
          .get('settings.userUpdatedInfo')
          .subscribe((text: string) => {
            this.toastr.success(text);
          });

          this.editCustomer.infoEmail = this.infoEmail;
      },
      (error) => {
        this.toastr.error(error.message);
      }
    );
  }

  updateCustomerSettings(body) {
    this.customerService
      .updateCustomerSettings(this.editCustomer.id, body)
      .subscribe(
        (res) => {
          // this.clientSettings = res;
          this.toastr.success('Success');
        },
        (err) => {}
      );
  }

  onChangeCustomer() {
    this.toggleChangeCustomer = true;
    this.customerService.getAll().subscribe(
      (res) => {
        this.customersData = res;
      },
      (err) => {}
    );
  }

  openCustomers() {
    this.showCustomers = !this.showCustomers;
    this.searchCustomersParam = '';
    this.customersSearch = this.customersData;
  }

  selectCustomer(customer) {
    this.selectedCustomer = customer;
    this.transferToParent = false;
  }

  onCloseCustomer() {
    this.toggleChangeCustomer = false;
    this.selectedCustomer = null;
  }

  applyCustomerFilter() {
    this.customersSearch = [];

    this.customersSearch = this.customersData.filter(
      (customer) =>
        customer.name
          .toLowerCase()
          .indexOf(this.searchCustomersParam.toLowerCase()) !== -1
    );
  }

  handleChangeToParent() {
    this.transferToParent = !this.transferToParent;
    this.selectedCustomer = null;
    // this.selectedCustomer = "parent customer";
  }

  transferCustomer() {
    if (!this.selectedCustomer && !this.transferToParent) {
      return;
    }

    let body = {
      newParentId: this.selectedCustomer?.id || null,
    };

    this.customerService.transferCustomer(this.customer.id, body).subscribe(
      (res) => {
        this.toastr.success('Customer transfered.');

        this.reloadCustomers.emit();

        this.toggleChangeCustomer = false;
      },
      (err) => {
        this.toggleChangeCustomer = false;
        this.toastr.error(err.error.description);
      }
    );
  }
}
